<div class="fake-mode-cover" *ngIf="isFakeMode"></div>
<ds-tabs
  [activeTabId]="activeTab"
  class="orders-tabs"
  [class.hide-header]="isFakeMode"
  [beforeContent]="manageActionsRef"
  (onActiveTabChange)="setActiveTab($event.tabId)">
  <ds-tab-head *ngFor="let tab of tabs"
               [tabId]="tab?.id"
               [activeTabId]="activeTab">
    <span [innerHTML]="tab.title"></span>
  </ds-tab-head>
  <ds-tab-content [tabId]="activeTab" [activeTabId]="activeTab">
    <section class="orders-wrapper">
      <div class="order-table-container {{orders?.length}}">
      <div class="db-order-id-column" [class.scrolled]="isScrollingHorizontal" *ngIf="orders?.length">
        <div class="head"><span>{{ 'text_orderNumber' | dbText }}</span></div>
        <div class="db-order-id-numbers" *ngFor="let order of orders">
          <div class="order-id row-item">
            <a class="db-link" [routerLink]="'./order-view/'+order?.id">#{{ order?.id }}</a>
            <span class="ds-test-small" *ngIf="!!order.hasTestEnvironment">{{ 'text_test' | dbText }}</span>
          </div>
        </div>
      </div>
      <db-orders-table (scroll)="onScroll($event)">
        <ng-container>
          <ng-container *ngIf="orders?.length; else emptyTable">
            <div class="list">
              <db-order-table-row
                *ngFor="let order of orders"
                (statusChanged)="changeStatus($event)"
                (removeItem)="onRemoveItem($event)"
                [websiteId]="website?.id"
                [order]="order">
              </db-order-table-row>
            </div>
          </ng-container>
          <ng-template #emptyTable>
            <div class="empty-table"
                 *ngIf="!loading">
              <span>{{ (searchTerm?.value?.length ? 'text_productsNoMatch' : 'text_ordersNoOrder')|dbText }}</span>
            </div>
          </ng-template>
        </ng-container>
        <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
      </db-orders-table>
      </div>
      <div class="pagination-wrapper" *ngIf="!searched">
        <ds-pagination-controls [rightNavigation]="!!isMobile"
                                [itemsCount]="100"
                                [itemsPerPage]="ordersPerPage"
                                [currentPage]="currentPage"
                                (onChangePage)="changePage($event)">
        </ds-pagination-controls>
      </div>
    </section>
  </ds-tab-content>
</ds-tabs>
<ng-template #manageActionsRef>
  <div class="orders__mange-actions">
    <div *ngIf="!isMobile">
      <ds-search-input class="orders__mange-actions-search"
                       [showLoading]="showSearchLoading"
                       [formControl]="searchTerm"
                       [placeholder]="'text_searchEllipsis' | dbText"
                       [hasSearchIcon]="true"></ds-search-input>
    </div>
    <span *ngIf="paymentMode === 'test'" class="db-test-mode">{{ 'text_testModeIsOn' | dbText }}</span>
  </div>
</ng-template>

